import './Home.css';
import homepageVideo1 from '../../assets/videos/homepage/homepage_video_1.mp4';
import homepageVideo2 from '../../assets/videos/homepage/homepage_video_2.mp4';
import model1 from '../../assets/images/homepage/model_1.jpeg';
import model2 from '../../assets/images/homepage/model_2.jpeg';
import model3 from '../../assets/images/homepage/model_3.jpeg';
import model5 from '../../assets/images/homepage/model_5.jpeg';
import model6 from '../../assets/images/homepage/model_6.jpeg';
import model7 from '../../assets/images/homepage/model_7.jpeg';
import model8 from '../../assets/images/homepage/model_8.jpeg';
import model9 from '../../assets/images/homepage/model_9.jpeg';
import model10 from '../../assets/images/homepage/model_10.jpeg';
import model11 from '../../assets/images/homepage/model_11.jpeg';
import model12 from '../../assets/images/homepage/model_12.jpeg';
import model13 from '../../assets/images/homepage/model_13.jpeg';

const HomePage = () => {
  return (
    <>
      <div className="home-page-layout">
      <section className="hero-panel fade-up">
        <div className="hero-copy">
          <span className="eyebrow">SRK PRODUCTION</span>
          <h1>Welcome to SRK Production</h1>
          <button type="button" className="hero-cta">
            Explore Now
          </button>
        </div>
        <div className="hero-visual">
          <div className="hero-image-small fade-down">
            <img src={model2} alt="Model 2" />
          </div>
          <div className="hero-image-large fade-up">
            <img src={model3} alt="Model 3" />
          </div>
        </div>
      </section>
    </div>


    <section className="feature-panel-wrapper fade-up">
      <div className="feature-panel-inner">
        <div className="feature-panel">
          <div className="feature-inner">
            <div className="feature-copy">
              <h2>Where Talent Meets Opportunity</h2>
              <p>
                At SRK Production, we believe that every individual has the potential to shine. Our mission is to discover, nurture, and promote talented people by providing them with a professional platform to showcase their abilities in the entertainment and fashion industries.
              </p>
            </div>
            <div className="feature-visual">
              <video
                src={homepageVideo1}
                autoPlay
                loop
                muted
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="fade-up w-100">
      <div className="feature-panel-inner">
        <div className="feature-panel">
          <div className="feature-inner">
            <div className="feature-visual">
              <img src={model13} alt="SRK Production feature" />
            </div>
            <div className="feature-copy text-gray">
              <h2>Who We Are?</h2>
                SRK Production is a talent promotion and entertainment company dedicated to creating opportunities for aspiring artists, models, actors, performers, and creative individuals. We work closely with industry professionals and collaborate with various production houses to help talented individuals build successful careers.

            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="feature-panel-wrapper fade-up">
      <div className="feature-panel-inner">
        <div className="feature-panel">
          <div className="feature-inner">
            <div className="feature-copy">
              <h2>What We Offer</h2>
              <p>
              We provide a platform for common people to showcase their talent and gain exposure in the entertainment industry. Fashion & Modeling Opportunities selected models are promoted as Show Stoppers in fashion and modeling events, helping them gain recognition and industry experience.
            </p>
            <ul>
              <li>Side Actor Roles</li>
              <li>Co-Actor Roles</li>
              <li>Main Lead Roles</li>
              <li>Second Lead Roles</li>
              <li>Character Roles</li>
              <li>Web Series Projects</li>
              <li>Short Films</li>
              <li>Music Videos</li>
              <li>Television Projects</li>
              <li>Brand Promotions</li>
            </ul>
            </div>
            <div className="feature-visual">
              <img src={model5} alt="SRK Production feature" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="fade-up w-100">
      <div className="feature-panel-inner">
        <div className="feature-panel ">
          <div className="">
            
            <div className="feature-visual my-4">
              <div className="marquee-container">
                <div className="marquee-track">
                  <div className="marquee-item"><img src={model6} alt="Model 6" /></div>
                  <div className="marquee-item"><img src={model7} alt="Model 7" /></div>
                  <div className="marquee-item"><img src={model8} alt="Model 8" /></div>
                  <div className="marquee-item"><img src={model9} alt="Model 9" /></div>
                  <div className="marquee-item"><img src={model10} alt="Model 10" /></div>
                  <div className="marquee-item"><img src={model11} alt="Model 11" /></div>
                  <div className="marquee-item"><img src={model12} alt="Model 12" /></div>
                  <div className="marquee-item"><img src={model6} alt="Model 6" /></div>
                  <div className="marquee-item"><img src={model7} alt="Model 7" /></div>
                  <div className="marquee-item"><img src={model8} alt="Model 8" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="feature-panel-wrapper fade-up">
      <div className="feature-panel-inner">
        <div className="feature-panel">
          <div className="feature-inner">
            <div className="feature-copy">
              <h2>Our Vision</h2>
              <p>
              To become one of India's leading talent promotion platforms by connecting aspiring artists with genuine opportunities in acting, modeling, fashion, television, films, and digital entertainment.
            </p>
            </div>
            <div className="feature-visual">
              <video
                src={homepageVideo2}
                autoPlay
                loop
                muted
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="fade-up w-100">
      <div className="feature-panel-inner">
        <div className="feature-panel">
          <div className="feature-inner">
            <div className="feature-visual">
              <img src={model1} alt="SRK Production feature" />
            </div>
            <div className="feature-copy text-gray">
              <h2>Our Mission</h2>
              <ul>
              <li>Discover hidden talent across India.</li>
              <li>Provide professional exposure and guidance.</li>
              <li>Create opportunities through auditions and events.</li>
              <li>Support aspiring artists in building successful careers.</li>
              <li>Connect talent with production houses and industry professionals.</li>
            </ul>

            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="feature-panel-wrapper fade-up">
      <div className="feature-panel-inner">
        <div className="feature-panel">
          <div className="feature-inner">
            <div className="feature-copy">
              <h2>Why Choose SRK Production?</h2>
            <ul className="checkmark-list">
              <li>Professional Platform for New Talent</li>
              <li>Fashion Show Opportunities</li>
              <li>Acting & Modeling Exposure</li>
              <li>Industry Networking</li>
              <li>Collaboration with Production Houses</li>
              <li>Career Growth Opportunities</li>
              <li>Talent Development Programs</li>
            </ul>
            </div>
            <div className="feature-visual">
              <img src={model5} alt="SRK Production feature" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <div className="home-page-layout">

      <section className="final-panel fade-up d-flex align-items-center justify-content-center">
          <div className="join-block text-center">
            <h3>Join SRK Production Today</h3>
            <p>
              Whether you dream of becoming a model, actor, performer, or entertainment professional, SRK Production is committed to helping you take the next step toward your career goals.
            </p>
            <p className="final-line">Your Talent, Our Platform, Unlimited Possibilities.</p>
          </div>
      </section>
    </div>
    </>
  );
};

export default HomePage;
